<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzTitle="Banners" nzSubtitle=" - Banners que ficarão nas páginas do site.">
        <nz-page-header-extra>
            <button nz-button nzType="primary" routerLink="lancamento"><i nz-icon nzType="plus"></i> Cadastrar</button>
        </nz-page-header-extra>
    </nz-page-header>

    <div nz-row>

        <div nz-col nzSpan="24">
            <nz-divider></nz-divider>
        </div>

        <div nz-col nzSpan="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="banners" [nzFrontPagination]="true" [nzLoading]="loading">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Banner</th>
                        <th>Link</th>
                        <th>Exibições</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td>{{data.idbanner}}</td>
                            <td>
                                <img [src]="data.path" alt="Banner {{data.idbanner}}" style="max-height: 60px; max-width: 180px;" />
                            </td>
                            <td>
                                <a *ngIf="data.link" href="{{data.link}}" target="_blank">Abrir Link</a>
                                <span *ngIf="!data.link">-</span>
                            </td>
                            <td>
                                <span *ngFor="let exibicao of data.exibicao; let isLast=last">
                                    {{ exibicao === 'HOME' ? 'Home' : exibicao === 'PESQUISA' ? 'Página de Pesquisa' : exibicao }}<span *ngIf="!isLast">, </span>
                                </span>
                            </td>
                            <td>
                                <button nz-button nz-dropdown [nzDropdownMenu]="menu">Operações<i nz-icon
                                            nzType="down"></i></button>
                                <nz-dropdown-menu #menu="nzDropdownMenu">
                                    <ul nz-menu>
                                        <li nz-menu-item>
                                            <a routerLink="lancamento/{{data.idbanner}}">Editar</a>
                                        </li>
                                        <li nz-menu-item>
                                            <a style="color:#f63849;" (click)="excluir(data.idbanner)">Excluir</a>
                                        </li>
                                    </ul>
                                </nz-dropdown-menu>
                            </td>
                        </tr>

                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>
